import { render, staticRenderFns } from "./PolicyDashboard.vue?vue&type=template&id=38473cab&scoped=true&"
import script from "./PolicyDashboard.vue?vue&type=script&lang=ts&"
export * from "./PolicyDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./PolicyDashboard.vue?vue&type=style&index=0&id=38473cab&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38473cab",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VDivider,VProgressCircular})
